import {Component, Input, OnInit, OnChanges, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {GroupViewVm} from 'src/app/view-model/group-view/group-view.vm';
import {AdvertisedProductsEvent} from '../../shared/event-listeners/advertised-products/advertised-products.event';

@Component({
  selector: 'app-advertised-products',
  templateUrl: './advertised-products.component.html',
  styleUrls: ['./advertised-products.component.scss'],
})
export class AdvertisedProductsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() products;
  @Input() modalStatus = null;
  isDiscountsLoaded = false;
  chargeProducts = false;
  carouselConfig = {
    rows: 2,
    slidesToShow: 5,
  };
  closeAdvertisedModal: Subscription;
  constructor(private advertisedProd: AdvertisedProductsEvent, private vm: GroupViewVm) {}

  ngOnInit() {
    this.chargeProducts = this.modalStatus && this.modalStatus.open;
    this.closeAdvertisedModal = this.advertisedProd.closeAdvertisedProducts.subscribe(closeModal => {
      if (closeModal === true) {
        this.close();
      }
    });

    this.isDiscountsLoaded = false;
    this.vm.getDiscounts(this.products).subscribe({
      next: updatedProducts => {
        this.products = updatedProducts;
        this.isDiscountsLoaded = true;
      },
      error: err => {
        console.error('Error al cargar descuentos en advertised-products:', err);
        this.isDiscountsLoaded = true;
      },
    });
  }

  ngOnChanges(): void {
    this.chargeProducts = this.modalStatus && this.modalStatus.open;
  }

  close() {
    this.modalStatus = {close: true};
  }

  ngOnDestroy() {
    this.closeAdvertisedModal.unsubscribe();
  }
}
